export default [
  { to: "/bible", name: "Bíblia" },
  { to: "/maps", name: "Como Chegar" },
  { to: "/podcast", name: "Podcast" },
  { to: "/devotional", name: "Devocional" },
  { to: "/contact", name: "Contato" },
  { to: "/admin", name: "adm" },
]